import { useTranslation } from 'react-i18next'
import type { CallOutcome } from '../../api/telemetry'

export type Outcome = CallOutcome

export const OUTCOME_STYLES: Record<Outcome, string> = {
  interested: 'bg-success/20 text-success',
  callback_requested: 'bg-primary/20 text-primary',
  not_interested: 'bg-text-muted/20 text-text-secondary',
  do_not_call: 'bg-error/20 text-error',
  voicemail: 'bg-warning/20 text-warning',
  no_answer: 'bg-text-muted/20 text-text-muted',
  wrong_number: 'bg-text-muted/20 text-text-secondary',
}

export const OUTCOME_VALUES: Outcome[] = [
  'interested',
  'callback_requested',
  'not_interested',
  'do_not_call',
  'voicemail',
  'no_answer',
  'wrong_number',
]

/** Returns the translated label for an outcome wire value. Falls back to the
 *  raw wire value when the outcome is unknown. */
export function useOutcomeLabel(outcome: string | undefined | null): string {
  const { t } = useTranslation('calls')
  if (!outcome) return ''
  return t(`outcomes.${outcome}`, { defaultValue: outcome })
}

/** Returns translated `{value, label}[]` for filter dropdowns. */
export function useOutcomeOptions(): { value: Outcome; label: string }[] {
  const { t } = useTranslation('calls')
  return OUTCOME_VALUES.map((value) => ({
    value,
    label: t(`outcomes.${value}`, { defaultValue: value }),
  }))
}
